export default __webpack_public_path__ + "static/media/jobdiva.3f00a808.svg";